import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { sendCertificateDTO } from 'app/dtos/mail/sendCertificateDTO';
import { CertificateService } from 'app/services/models/certificate.service';

@Component({
  selector: 'app-send-certificate-mail',
  templateUrl: './send-certificate-mail.component.html',
  styleUrls: ['./send-certificate-mail.component.scss']
})
export class SendCertificateMailComponent implements OnInit {
  @Input() data: sendCertificateDTO;

  constructor(
    private modal: NgbActiveModal,
    private certificateService: CertificateService) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  close(result: boolean = false) {
    this.modal.close(result);
  }

  async onSubmit() {
    try {
      await this.certificateService.sendCertificate(this.data);
      this.close(true);
    } catch (err) {
      console.error("Sertifika gönderilirken hata oluştu:", err);
    }
  }
}
